import {
  quartiles,
  managementFee,
  incentiveFee,
  timeframes,
  yearsOperating
} from 'buyside/util/fundProfileFilterConstants';
import { titleize } from 'inflection';

const quartileCategories = ['return_quartile', 'beta_metric', 'sharpe_metric', 'turnover_metric'];

const filterFormatFundSearch = (value, category) => {
  if (quartileCategories.indexOf(category) > -1) {
    return {
      value: quartiles.find(quartile => quartile.value === value).label,
      category: titleize(category.replace('return_', '').replace('_metric', ''))
    };
  } else if (category === 'return_timeframe') {
    return {
      value: timeframes.find(timeframe => timeframe.value === value).label,
      category: 'Timeframe'
    };
  } else if (category === 'management_fee') {
    return {
      value: managementFee.find(fee => fee.value === value).label,
      category: titleize(category)
    };
  } else if (category === 'incentive_fee') {
    return {
      value: incentiveFee.find(fee => fee.value === value).label,
      category: titleize(category)
    };
  } else if (category === 'years_operating') {
    return {
      value: yearsOperating.find(year => year.value === value).label,
      category: titleize(category)
    };
  } else {
    return { value, category };
  }
};

export default filterFormatFundSearch;
